const classActionTypes = {
    SET_ACTIVE_CLASS: "SET_ACTIVE_CLASS"
}

export default classActionTypes